import { render, staticRenderFns } from "./liveComment.vue?vue&type=template&id=b27d3366&"
import script from "./liveComment.vue?vue&type=script&lang=js&"
export * from "./liveComment.vue?vue&type=script&lang=js&"
import style0 from "./liveComment.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./liveComment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports